const getPathForCookie = (path) => {
    path = path || window.location.pathname
    let pathParts = path.split('/')
    
    if (path.charAt(path.length - 1) !== '/' && pathParts[pathParts.length - 1].indexOf('.') !== -1) {
        pathParts.splice(pathParts.length - 1, 1)
        path = pathParts.join('/') + '/'
    }

    return path
}

export const setCookie = (key, value, expires, path) => {
    if (!key || value === undefined || typeof key !== 'string') 
        return
    
    path = path || getPathForCookie()
    let expiration = new Date()
    let objToSave = {}

    if (expires && typeof expires === 'number') {
        expiration.setHours(0, 0, 0, 0)
        expiration.setDate(expiration.getDate() + expires)
        objToSave.expires = expiration
    }

    document.cookie = key + '=' + escape(JSON.stringify(value)) + ((expires) ? '; expires=' + expiration.toUTCString() : '') + '; path=' + path   
}

export const getCookie = (key) => {
    if (!key || typeof key !== 'string') 
        return null

    const cookies = document.cookie.split(';')
    const cookiesLength = cookies.length

    for (let i = 0; i < cookiesLength; i++) {
        let cookieValue = unescape(cookies[i].substr(cookies[i].indexOf('=') + 1))
        if (cookieValue) {
            let cookieName = cookies[i].substr(0, cookies[i].indexOf('='))
            cookieName = cookieName.replace(/^\s+|\s+$/g, '')
            if (cookieName === key) 
                return JSON.parse(cookieValue)
        }
    }

    return null
}

export const removeCookie = (key, path) => {
    if (!key || !value || typeof key !== 'string') 
        return

    path = path || getPathForCookie()

    document.cookie = key + '=; expires=-1; path=' + path
}